var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one-form-item"},[_c('label',{staticClass:"one-form-item_label",style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"one-form-item_content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }